/** @file Curves tab body (inside the Timeline panel): toolbar plus the Canvas2D value/time graph. */
import './curves.css';
import { useRef } from 'react';
import { useT } from '../../shell/i18n/useT';
import type { CurvePorts } from './curvePorts';
import { CurvesToolbar } from './CurvesToolbar';
import { useCurveBindings } from './useCurveBindings';
import { useCurveCanvas } from './useCurveCanvas';
import { useCurveModel } from './useCurveModel';
import { useCurvePointer } from './useCurvePointer';

/** The graph paints imperatively on rAF; React renders only the toolbar, the canvas element and the empty hint. */
export function CurvesView({ ports }: { ports: CurvePorts }) {
  const t = useT();
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const model = useCurveModel(ports);
  const last = useCurveCanvas(canvasRef, model);
  const handlers = useCurvePointer(last, model, ports);
  useCurveBindings(canvasRef);
  return (
    <div className="p2-curves" data-testid="curves-view">
      <CurvesToolbar model={model} ports={ports} />
      <div className="p2-curves-body">
        <canvas ref={canvasRef} className="p2-curves-canvas" tabIndex={0} aria-label={t('curves.graph')} {...handlers} />
        {model.tracks.length === 0 ? <p className="p2-curves-empty">{t('curves.empty')}</p> : null}
      </div>
    </div>
  );
}
